import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardActionsContainer } from '../CardActionsContainer';
import { BookButtonContainer } from '../BookButtonContainer';
import { FillFormButtonMobile } from '../../components/FillFormButtonMobile';
import { isRenterFormEnabled } from '../../selectors/isRenterFormEnabled';
import { trackSafeRentFillFormClick } from './tracking';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';
import { useIsDailyrentOnlineBooking } from '../../hooks/useIsDailyrentOnlineBooking';
import { OnlineBookingCardActionsContainer } from '../OnlineBookingCardActionsContainer';

interface IProps {
  offerId: number;
  position: number;
}

export const ContactButtonsContainer = ({ offerId, position }: IProps) => {
  const offer = useSelector(selectRecommendationById(offerId));
  const { url = '', dealRentEnabled, isCianPartner, canBeBooked = false } = offer || {};

  const isRenterFormEnabledFlag = useSelector(isRenterFormEnabled);
  const isDailyrentOnlineBooking = useIsDailyrentOnlineBooking();

  const onFillFormClick = React.useCallback(() => {
    trackSafeRentFillFormClick(offerId);
  }, [offerId]);

  if (isCianPartner) {
    return <BookButtonContainer url={url} canBeBooked={canBeBooked} />;
  }

  if (isDailyrentOnlineBooking) {
    return <OnlineBookingCardActionsContainer offerId={offerId} position={position} />;
  }

  if (isRenterFormEnabledFlag && dealRentEnabled) {
    return <FillFormButtonMobile onClick={onFillFormClick} href={url} />;
  }

  return <CardActionsContainer offerId={offerId} />;
};
